import {Requestable} from './Interface/Requestable';
import {Observable} from 'rxjs/Rx';
import {Injectable} from '@angular/core';
import {HttpClient, HttpRequest, HttpResponse} from '@angular/common/http';
export class HttpProxy implements Requestable {
/**
 * @param {?} http
 */
constructor(public http: HttpClient) {

    }
/**
 * @param {?} request
 * @return {?}
 */
public request(request: HttpRequest<any>): Observable<HttpResponse<any> | any> {
        return this.http.request<any>(request);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
];
}

function HttpProxy_tsickle_Closure_declarations() {
/** @type {?} */
HttpProxy.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HttpProxy.ctorParameters;
/** @type {?} */
HttpProxy.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
